
export const ITEM_WISE_BULK_UPDATE_GO_BUTTON_ACTION = "ITEM_WISE_BULK_UPDATE_GO_BUTTON_ACTION"
export const ITEM_WISE_BULK_UPDATE_GO_BUTTON_SUCCESS = 'ITEM_WISE_BULK_UPDATE_GO_BUTTON_SUCCESS'

export const ITEM_WISE_BULK_UPDATE_SAVE_ACTION = "ITEM_WISE_BULK_UPDATE_SAVE_ACTION"
export const ITEM_WISE_BULK_UPDATE_SAVE_SUCCESS = 'ITEM_WISE_BULK_UPDATE_SAVE_SUCCESS'

export const ITEM_SUPPLIER_LIST_ACTION = "ITEM_SUPPLIER_LIST_ACTION"
export const ITEM_SUPPLIER_LIST_SUCCESS = 'ITEM_SUPPLIER_LIST_SUCCESS'

export const ITEM_WISE_BULK_UPDATE_API_ERROR_ACTION = 'ITEM_WISE_BULK_UPDATE_API_ERROR_ACTION'